// Instancias de partido - codigoInstancia del EditPartidoDTO
export const UNICO = 'U';
export const IDA = 'I';
export const VUELTA = 'V';

// Descripción de cada instancia
export const Descripcion = {
  [UNICO]: 'Único',
  [IDA]: 'Ida',
  [VUELTA]: 'Vuelta',
};
